import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, NgZone, OnInit } from '@angular/core';
import { FuiDestroyService } from '@services/destroy.service';
import { takeUntil, timer } from 'rxjs';

/**
 * Дата и время в информации о пользователе бокового меню.
 * Обновляет показания на границе минуты вне Angular, проверяя только собственный шаблон.
 * Таймер останавливается при удалении компонента вместе с меню.
 */
@Component({
    selector: 'app-side-menu-date-time',
    template: '{{ currentDateTime | date: "EEE dd MMM YYYY г. HH:mm" }}',
    standalone: true,
    imports: [DatePipe],
    providers: [FuiDestroyService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuDateTimeComponent implements OnInit {
    private readonly zone = inject(NgZone);

    private readonly cdr = inject(ChangeDetectorRef);

    private readonly destroy$ = inject(FuiDestroyService);

    /** Текущее время для отображения даты, часов и минут. */
    currentDateTime = new Date();

    /** Запустить локальное обновление часов без общей проверки приложения. */
    ngOnInit(): void {
        this.zone.runOutsideAngular(() => {
            timer(60_000 - (Date.now() % 60_000), 60_000)
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    this.currentDateTime = new Date();
                    this.cdr.detectChanges();
                });
        });
    }
}
